import React from "react";

function ListTable() {
  return (
    <div className="table-responsive table-instru">
      <table className="table table-bordered">
        <thead className="table-light">
            <tr>
                <th className="text-center">工程</th>
                <th className="text-center">設備</th>
                <th className="text-center">メーカー</th>
                <th className="text-center">台数</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td className="text-center" rowSpan={3}>プレス</td>
                <td className="text-center">250トントランスファープレス</td>
                <td className="text-center">Aida</td>
                <td className="text-center">2</td>
            </tr>
            <tr>
                <td className="text-center">150t プレス</td>
                <td className="text-center">Komatsu, Amada</td>
                <td className="text-center">10</td>
            </tr>
            <tr>
                <td className="text-center">110t プレス</td>
                <td className="text-center">Aida</td>
                <td className="text-center">5</td>
            </tr>

            <tr>
                <td className="text-center">CNC切削</td>
                <td className="text-center">マシニングセンタ</td>
                <td className="text-center">Brother, Jingdiao</td>
                <td className="text-center">65</td>
            </tr>

            <tr>
                <td className="text-center" rowSpan={8}>二次加工</td>
                <td className="text-center">洗浄機</td>
                <td className="text-center">-</td>
                <td className="text-center">2</td>
            </tr>
            <tr>
                <td className="text-center">回転バレル研磨機</td>
                <td className="text-center">-</td>
                <td className="text-center">8</td>
            </tr>
            <tr>
                <td className="text-center">振動バレル研磨機</td>
                <td className="text-center">-</td>
                <td className="text-center">2</td>
            </tr>
            <tr>
                <td className="text-center">エアーブラスト機</td>
                <td className="text-center">-</td>
                <td className="text-center">3</td>
            </tr>
            <tr>
                <td className="text-center">レーザーマーカー</td>
                <td className="text-center">Keyence</td>
                <td className="text-center">5</td>
            </tr>
            <tr>
                <td className="text-center">タンポ印刷機</td>
                <td className="text-center">Navitas</td>
                <td className="text-center">7</td>
            </tr>
            <tr>
                <td className="text-center">色入れ機</td>
                <td className="text-center">Musashi</td>
                <td className="text-center">3</td>
            </tr>
            <tr>
                <td className="text-center">スポット溶接機</td>
                <td className="text-center">Shindengen</td>
                <td className="text-center">1</td>
            </tr>

            <tr>
                <td className="text-center" rowSpan={2}>アルマイト加工</td>
                <td className="text-center">小型量産・試作ライン</td>
                <td className="text-center">-</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">量産ライン (5色/ライン)</td>
                <td className="text-center">-</td>
                <td className="text-center">2</td>
            </tr>

            <tr>
                <td className="text-center" rowSpan={6}>金型治具加工・メンテナンス</td>
                <td className="text-center">ワイヤー放電加工</td>
                <td className="text-center">Mitsubishi</td>
                <td className="text-center">2</td>
            </tr>
            <tr>
                <td className="text-center">細穴放電加工</td>
                <td className="text-center">Mitsubishi</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">CNC切削</td>
                <td className="text-center">Brother</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">フライス盤</td>
                <td className="text-center">-</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">研削盤</td>
                <td className="text-center">-</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">旋盤</td>
                <td className="text-center">-</td>
                <td className="text-center">1</td>
            </tr>

            <tr>
                <td className="text-center" rowSpan={6}>測定機器</td>
                <td className="text-center">三次元測定機 (CMM)</td>
                <td className="text-center">Mitsutoyo, Hexagon</td>
                <td className="text-center">2</td>
            </tr>
            <tr>
                <td className="text-center">画像寸法測定機 (OMM)</td>
                <td className="text-center">Mitsutoyo</td>
                <td className="text-center">3</td>
            </tr>
            <tr>
                <td className="text-center">画像寸法測定機 (IM)</td>
                <td className="text-center">Keyence</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">3D スキャナー</td>
                <td className="text-center">Solutionix</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">引っ張り試験機</td>
                <td className="text-center">Comtex</td>
                <td className="text-center">1</td>
            </tr>
            <tr>
                <td className="text-center">アルマイト色,膜厚,粗度測定機</td>
                <td className="text-center">-</td>
                <td className="text-center">1</td>
            </tr>
        </tbody>
      </table>
    </div>
  );
}

export default ListTable;